import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function cadastromarca(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@cadastromarca/FIND_CADASTROMARCA':
      case '@cadastromarca/UPDATE_CADASTROMARCA':
      case '@cadastromarca/DELETE_CADASTROMARCA':
      case '@cadastromarca/STORE_CADASTROMARCA':
      case '@cadastromarca/CADASTROMARCA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@cadastromarca/SUCCESS_REMOVE':
      case '@cadastromarca/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@cadastromarca/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.cadastromarca;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@cadastromarca/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.cadastromarca;
        break;
      }

      case '@cadastromarca/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
